export const createOption = ({ value, label, selected }) => {
    const optionElement = document.createElement('option');
    optionElement.value = value;
    optionElement.text = label;
    if (selected) {
        optionElement.selected = selected;
    }
    return optionElement;
};
//# sourceMappingURL=createOption.js.map